export default {
  MARKET_RECOMMENDATION_BUNDLE_CREDIT_SCORE_SPEND: 'market_recommendation_bundle_credit_score_spend',
  MARKET_RECOMMENDATION_BUNDLE_BEST_OF_AWARDS: 'market_recommendation_bundle_best_of_awards',
  MARKET_RECOMMENDATION_BUNDLE_CREDIT_SCORE_ONLY: 'market_recommendation_bundle_credit_score_only'
};